<template>
  <div class="p-d-flex p-flex-column" style="cursor: pointer">
    <div v-for="(assessment, index) in assessments" :key="index">
      <div class="p-d-flex p-align-start">
        <!-- <SubmitApprovePanel
          :badgeOnly="true"
          :approveOn="assessment.approveOn"
          :employeeDirty="!!assessment.assessmentData"
          :supervisorDirty="!!assessment.supervisorAssessmentData"
          :submitOn="assessment.submitOn"
          v-tooltip="`${assessment.question?.name}`"
        /> -->
        <span v-tooltip="`${assessment.question?.name ?? 'N/A'}`">
          <StatusBadge
            :status="assessment.status"
            @click="onShowAssessment(assessment)"
          ></StatusBadge
        ></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onMounted } from "vue";
import { TrainingAssessment, TrainingAttendance } from "@/types";
import StatusBadge from "@/components/StatusBadge.vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "AssessmentBadge",
  components: { StatusBadge },
  props: {
    attendance: {
      type: Object as PropType<TrainingAttendance>,
      required: true,
    },
  },
  setup(props) {
    const assessments = ref<TrainingAssessment[]>([]);

    const { error, onRouterPush } = usePlugin();
    const onShowAssessment = (assessment: TrainingAssessment) => {
      if (
        props.attendance.employeeId == null ||
        props.attendance.trainingDocumentId == null
      ) {
        error("ข้อมูลไม่ถูกต้อง");
        return;
      }
      onRouterPush({
        name: "viewAssessment",
        params: {
          documentId: assessment.trainingDocumentId ?? "",
          employeeId: assessment.employeeId ?? "",
          questionId: assessment.questionId?.toString() ?? "",
        },
      });
    };

    onMounted(() => {
      assessments.value = props.attendance.assessments ?? [];
    });

    return { onShowAssessment, assessments };
  },
});
</script>

<style></style>
